<template>
<div v-if="listDataActive">
  <a :class="{'text-danger': isPresentInList, 'text-success': !isPresentInList}" href="" @click.prevent="addOrRemove">{{ isPresentInList ? '- Remove from' : '+ Add to' }}  active list</a>
</div>
</template>

<script>
export default {
  props: {
    orderId: {
      type: Number,
      default: null
    },
    listDataActive: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    addOrRemove() {
      if (this.isPresentInList) {
        this.removeFromList()
      } else {
        this.addToList()
      }
    },
    addToList() {
       this.$store.dispatch("ordersList/addToTempOrderIdsForAdding", this.orderId)
    },
    removeFromList() {
      this.$store.dispatch("ordersList/addToTempOrderIdsForRemoval", this.orderId)
    }
  },
  computed: {
    isPresentInList() {
      let present = false;
      this.$store.state.ordersList.idsOfOrdersInList.forEach(order => {
        if (order.id == this.orderId && !this.$store.state.ordersList.temporaryIdsForRemoving.includes(this.orderId)) {
          present = true
        }
      });
      this.$store.state.ordersList.temporaryIdsForAdding.forEach(id => {
         if(id == this.orderId){
           present = true;
         }
      })
      return present;
    },
    activeOrdersList() {
      return this.$store.state.ordersList.activeList
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
